import { TextField } from "@mui/material";
import InputBox from "./InputBox";
import { PField } from "./NestedField";
import { fieldHasError, requiredValidator } from "./validator";

export default function TextInput({ name, initialValue, required, helperText, format, parse, sx, ...props }) {
    return (
        <InputBox sx={sx}>
            <PField
                name={name}
                initialValue={initialValue}
                validate={required ? requiredValidator : null}
                format={format}
                parse={parse}
            >
                {(fieldProps) => {
                    const hasError = fieldHasError(fieldProps.meta);

                    return (
                        <TextField
                            variant="standard"
                            required={required}
                            error={hasError}
                            helperText={hasError ? fieldProps.meta.error : helperText}
                            sx={{ flex: 1 }}
                            {...fieldProps.input}
                            {...props}
                        />
                    );
                }}
            </PField>
        </InputBox>
    );
}
